module.exports = __webpack_public_path__ + "static/about_standardy-1d2ae6162a15e3751bdabaea43500c4c.jpg";